import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { X, Crown } from "lucide-react";

interface SubscriptionRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SubscriptionRequiredModal = ({ isOpen, onClose }: SubscriptionRequiredModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSubscribe = () => {
    onClose();
    navigate("/#pricing");
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="
        bg-[#F5F0E8] border-2 border-black rounded-xl
        w-full max-w-md mx-4 p-6
        shadow-[8px_8px_0_#1A1A1A]
      ">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-[#FF6B9D] border-2 border-black rounded-xl flex items-center justify-center">
              <Crown className="w-6 h-6" />
            </div>
            <h2 className="text-xl font-bold">
              {t("subscription.trialExpired.title")}
            </h2>
          </div>
          <button 
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <p className="text-gray-700 mb-6">
          {t("subscription.trialExpired.message")}
        </p>

        {/* Actions */}
        <div className="flex gap-3">
          <button 
            onClick={onClose}
            className="flex-1 px-4 py-3 border-2 border-black rounded-lg bg-white font-medium hover:bg-gray-50"
          >
            {t("common.cancel")}
          </button>
          <button 
            onClick={handleSubscribe}
            className="
              flex-1 px-4 py-3 border-2 border-black rounded-lg
              bg-[#FF6B9D] font-bold
              hover:translate-x-0.5 hover:translate-y-0.5
              hover:shadow-[4px_4px_0_#1A1A1A]
              transition-all duration-100
            "
          >
            {t("subscription.trialExpired.subscribe")}
          </button>
        </div>
      </div>
    </div>
  );
};
